import {
	IPlatformAuthorizer,
	IPlatformRouter,
	IPlatformUi,
	IPlatformContext,
} from '@studyportals/scholarships-editor-integration';

import { PlatformAuthorizerDecoratorUiLoader } from '../infrastructure/ui-loader/platform-authorizer-decorator-ui-loader';

export class PlatformIntegration {
	public static readonly instance = new PlatformIntegration();

	private _context: IPlatformContext | undefined;
	private _router: IPlatformRouter | undefined;
	private _authorizer: IPlatformAuthorizer | undefined;
	private _ui: IPlatformUi | undefined;

	private constructor() {
		// Restrict instantiation access
	}

	public get context(): IPlatformContext {
		if (this._context === undefined) {
			throw new Error('The platform context has not been set');
		}

		return this._context;
	}

	public set context(value: IPlatformContext) {
		this._context = value;
	}

	public get router(): IPlatformRouter {
		if (this._router === undefined) {
			throw new Error('The platform router has not been set');
		}

		return this._router;
	}

	public set router(value: IPlatformRouter | undefined) {
		this._router = value;
	}

	public get authorizer(): IPlatformAuthorizer {
		if (this._authorizer === undefined) {
			throw new Error('The platform authorizer has not been set');
		}

		return this._authorizer;
	}

	public set authorizer(value: IPlatformAuthorizer | undefined) {
		this._authorizer = value !== undefined ? new PlatformAuthorizerDecoratorUiLoader(value) : undefined;
	}

	public get ui(): IPlatformUi {
		if (this._ui === undefined) {
			throw new Error('The platform UI has not been set');
		}

		return this._ui;
	}

	public set ui(value: IPlatformUi | undefined) {
		this._ui = value;
	}
}
